import React, { useEffect, useState, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '../../Store';
import { play } from '../../helpers/remember-me/play';
import { DEFAULT_ERROR_CODE, MESSAGE_CONTEXTS } from '../../helpers/server-messages';
import { metrics } from '../../metrics-config';
import { useTranslation } from 'react-i18next';
import * as emailFlowHelpers from '../../helpers/email-flow';
import Modal from '../modals/Modal';

function OldReturningUserFlow({ isAuthenticated = null }) {
	const [state, dispatch] = useContext(AppContext);
	const { t } = useTranslation('translation');

	const isEmailFlow = useMemo(() => emailFlowHelpers.isEmailFlow(), []);
	const emailConfirmationMessage = useMemo(() => {
		const serverMessages = state.serverMessages;
		return serverMessages?.length > 0 && serverMessages.find((el) => MESSAGE_CONTEXTS.EMAIL_CONFIRMATION.some((context) => context === el.context));
	}, [state.serverMessages]);

	const [showEmailConfirmation, setShowEmailConfirmation] = useState(false);
	const [showCloseButton, setShowCloseButton] = useState(false);
	const [shouldLogin, setShouldLogin] = useState(false);
	const [redirectTimeout, setRedirectTimeout] = useState(0);

	useEffect(() => {
		if (isAuthenticated !== null) {
			if (!isEmailFlow && isAuthenticated) {
				console.log('Old Returning User Flow...... does not come from email flow but has a cookie');
				console.log('Old Returning User Flow...... instantly call /play');
				setShouldLogin(true);
			}

			else if (isEmailFlow && !isAuthenticated) {
				console.log('Old Returning User Flow...... has the query param and has no cookie');
				console.log('Old Returning User Flow...... show EmailModal');
				setShowEmailConfirmation(true);
				setShowCloseButton(true);
			}
	
			else if (isEmailFlow && isAuthenticated) {
				console.log('Old Returning User Flow...... has the query param and has a cookie');
				console.log('Old Returning User Flow...... show EmailModal and call /play after x seconds');
				setShowEmailConfirmation(true);
				setRedirectTimeout(5000);

				setShouldLogin(true);
			} else {
				console.log('Old Returning User Flow...... stay on the page');
			}
		}
	}, [isAuthenticated, isEmailFlow]);

	useEffect(() => {
		function login() {
			setTimeout(async() => {
				try {
					const playResult = await play();
		
					if (playResult.errors && playResult.errors.length !== 0) {
						dispatch({ type: 'SET_SERVER_ERROR_MESSAGE', payload: t(playResult.errors[0].code) });
						dispatch({ type: 'SHOW_SERVER_ERROR' });
					} else if (playResult.redirectUrl) {
						const playerId = playResult.playerId;
						if (playerId && metrics) {
							metrics.collectAccountLoginMetrics(playerId, playResult.redirectUrl);
						}
	
						window.location.href = playResult.redirectUrl;
					}
				} catch (error) {
					console.log('Old Returning User Flow...... Error: ', error);
					dispatch({ type: 'SET_SERVER_ERROR_MESSAGE', payload: t(DEFAULT_ERROR_CODE) });
					dispatch({ type: 'SHOW_SERVER_ERROR' });
				}
			}, redirectTimeout);
		}

		if (shouldLogin) {
			login();
		}
	}, [shouldLogin, redirectTimeout, t, dispatch]);

	return (
		<div>
			{showEmailConfirmation && (
				<Modal
					isShownAsOverlay
					hasCloseButton={showCloseButton}
					title={t('emailConfirmation.header')}
					closeCallback={() => setShowEmailConfirmation(false)}
					closeButtonId={''}
				>
					<div>
						<p>{emailConfirmationMessage ?
							t(emailConfirmationMessage.code) :
							t('be.api.emailConfirmation.confirmationCodeInvalid')
						}</p>
						<p>{shouldLogin && t('server.emailConfirmation.redirect')}</p>
					</div>	
				</Modal>
			)}
		</div>
	);
}

export default OldReturningUserFlow;

OldReturningUserFlow.propTypes = {
	isAuthenticated: PropTypes.bool,
};